import { HttpClient } from '@/core/utils/httpClient'
import { TLoginData, TLoginResponse } from '@/modules/session/models/Auth.model'

export class AuthRepository extends HttpClient {
  async login(data: TLoginData): Promise<TLoginResponse> {
    return await this.post('/auth/login', data)
  }
}
